
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

export const useAuth = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleLogin = async (loginEmail: string, loginPassword: string, rememberMe: boolean = true) => {
    setLoading(true);

    try {
      const { error } = await supabase.auth.signInWithPassword({
        email: loginEmail,
        password: loginPassword,
      });

      if (error) throw error;

      if (!rememberMe) {
        // Clear any stored session when remember me is not checked
        localStorage.removeItem("sb-session");
      }

      toast.success("Successfully signed in!");
      navigate("/");
    } catch (error: any) {
      toast.error(error.message || "Error signing in");
    } finally {
      setLoading(false);
    }
  };

  const handleSignup = async (
    email: string,
    password: string,
    fullName: string,
    whatsapp: string,
    gender: string,
    birthday: Date | undefined
  ) => {
    setLoading(true);

    try {
      const { data: authData, error: signUpError } = await supabase.auth.signUp({
        email,
        password,
      });

      if (signUpError) throw signUpError;

      if (authData.user) {
        const { error: profileError } = await supabase
          .from("profiles_pending")
          .insert({
            id: authData.user.id,
            full_name: fullName,
            email,
            whatsapp,
            gender,
            birthday: birthday?.toISOString().split('T')[0],
          });

        if (profileError) throw profileError;
      }

      toast.success("Successfully signed up! Please check your email for verification.");
      navigate("/auth");
    } catch (error: any) {
      toast.error(error.message || "Error signing up");
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    handleLogin,
    handleSignup,
  };
};
